import { createApp, ref, reactive, onMounted, computed } from 'vue'

const app = createApp({
  setup() {
    const carArray = reactive([])
    const timeArray = reactive([])
    const errorStatement = reactive([])
    const messageStatement = reactive({})
    const buttonStatement = ref(false)

    onMounted(() => {
      for (let i = 0; i < document.querySelectorAll('.c-select-box--car').length; i++) {
        carArray[i] = Number(document.querySelectorAll('.c-select-box--car')[i].value)
      }
      for (let j = 0; j < document.querySelectorAll('.c-select-box--time').length; j++) {
        timeArray[j] = Number(document.querySelectorAll('.c-select-box--time')[j].value)
        errorStatement[j] = { car: false, time: false }
      }
    })

    const carChange = (event, number) => {
      carArray[number] = Number(event.target.value)
      if (event.target.value != 0 && timeArray[number] === 0) {
        errorStatement[number].time = true
      } else if (event.target.value == 0 && timeArray[number] !== 0) {
        errorStatement[number].car = true
      } else {
        errorStatement[number].car = false
        errorStatement[number].time = false
      }
      errorCheck()
    }

    const timeChange = (event, number) => {
      timeArray[number] = Number(event.target.value)
      if (event.target.value != 0 && carArray[number] === 0) {
        errorStatement[number].car = true
      } else if (event.target.value == 0 && carArray[number] !== 0) {
        errorStatement[number].time = true
      } else {
        errorStatement[number].car = false
        errorStatement[number].time = false
      }
      errorCheck()
    }

    const errorCheck = () => {
      if (errorStatement.filter((item) => item.car === true).length > 0) {
        messageStatement.car = true
      } else {
        messageStatement.car = false
      }
      if (errorStatement.filter((item) => item.time === true).length > 0) {
        messageStatement.time = true
      } else {
        messageStatement.time = false
      }
      if (messageStatement.car === true || messageStatement.time === true) {
        buttonStatement.value= true
      } else {
        buttonStatement.value = false
      }
    }

    return { carArray, timeArray, carChange, timeChange, errorStatement, buttonStatement, messageStatement }
  }
})
if (document.getElementById('carryControl')) {
  app.mount('#carryControl')
}
